export const useWeekDays = () => useState('week_days', () => [
    'Domenica',
    'Lunedì',
    'Martedì',
    'Mercoledì',
    'Giovedì',
    'Venerdì',
    'Sabato',
])

export const useGyms = () => useState('gyms', () => [
    { id: 1, label: 'Natked - Milano' },
    { id: 2, label: 'Natked - Montello' },
])


export const useWorkingWeekDays = () => useState('working_week_days', () => [
    // { id: 0, label: 'Domenica' },
    { id: 1, label: 'Lunedì' },
    { id: 2, label: 'Martedì' },
    { id: 3, label: 'Mercoledì' },
    { id: 4, label: 'Giovedì' },
    { id: 5, label: 'Venerdì' },
    { id: 6, label: 'Sabato' },
])

export const useBooleanSelectValues = () => useState('boolean_select_values', () => [
    { id: 'no', label: 'No' },
    { id: 'yes', label: 'Sì' },
])

export const useIncomeTypes = () => useState('income_types', () => [
    { id: 1, name: 'Rata pacchetto' },
    { id: 2, name: 'Quota associativa' },
    { id: 3, name: 'Aziende' },
    { id: 4, name: 'Academy' },
    { id: 100, name: 'Altro' },
])

export const useIsLoading = () => useState('is_loading', () => false)

export const useClassTypes = () => useState('class_types', () => [])

export const useCustomers = () => useState('customers', () => [])

export const useCustomersSelectValues = () => useState('customers_select_values', () => [])

export const usePaymentMethods = () => useState('payment_methods', () => [])

export const useInvoiceCompanies = () => useState('invoice_companies', () => [])

export const useServiceCategories = () => useState('service_categories', () => [])

export const useTrainers = () => useState('trainers', () => [])

export const useTrainersSelectValues = () => useState('trainers_select_values', () => [])

export const useTrainerCategories = () => useState('trainer_categories', () => [])

export const useActiveTrainers = () => useState('active_trainers', () => [])

export const useServices = () => useState('services', () => [])

export const useVenues = () => useState('venues', () => [])
